﻿import React, { useState, useEffect, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import slugify from 'slugify';
import { ProductProps } from './Interfaces';
import { ProductImage, ProductSelector, Price, ProductBuyer } from './Components';

export function Product(props: ProductProps) {
    const [id, setId] = useState(props.product.variants[0].id);

    const variant = props.product.variants.find(x => x.id === id);
    const ordered = props.cart.products.find(x => x.productVariantId === id)?.quantity ?? 0;

    function variantSelected(id: number) {
        const selected = props.product.variants.find(x => x.id === id);

        setId(selected.id);
    }

    function qtyChanged(qty: number) {
        props.itemCountChanged(props.product.id, id, qty);
    }        

    const productTo = `/Shop/Product/${props.product.id}-${slugify(props.product.name)}`;

    return (
        <div className="product">
            <NavLink className="d-block" to={productTo}>
                <ProductImage image={props.product.image} />
            </NavLink>
            {ordered > 0 ? <div className="p-qty-overlay">{ordered} in cart</div> : null}
            <div className="p-info">
                <NavLink className="d-block" to={productTo}>
                    <h4 className="p-title">{props.product.name}</h4>                    
                </NavLink>
                {props.product.linkSupplier ? <a className="p-supplier" href={`/Suppliers/${props.product.supplierId}/${slugify(props.product.supplier, { lower: true })}`}>{props.product.supplier}</a> : <span className="p-supplier">{props.product.supplier}</span>}
                <ProductSelector product={props.product} variant={variant} variantSelected={variantSelected} />

                <div className="flex-grow-1">
                </div>

                <Price product={props.product} variant={variant} />

                <div className="p-buy">
                    <ProductBuyer qty={ordered} setQty={qtyChanged} inStock={props.product.inStock} canEdit={props.cart.status === 'Active'} shopOpen={props.shopOpen} loggedIn={props.loggedIn} preview={props.product.preview} />                    
                </div>
            </div>
        </div>
    );
}